export const RadioAddressData = [
  { label: 'Aux coordonnées principales', value: 1 },
  { label: 'À une adresse différente', value: 2 }
]
